import { AxiosError } from 'axios';
import { PASS_ERROR_MESSAGE } from 'viewup-lib/common';

type PassHandledMeta = { errorMessage?: Record<string, string> } | undefined;

/**
 * 해당 에러가 `PASS_ERROR_MESSAGE`로 매핑되어 **조용히 삼켜지는 정상 사용자 플로우**인지 판정한다.
 *
 * - `AlreadySubmittedLink`(중복 링크 제출) · `BlogPostNotOwned` · `ForbiddenCi` 등은 서버가 에러
 *   응답으로 내려주지만, 앱은 `mutation.meta.errorMessage[code] === PASS_ERROR_MESSAGE`로 매핑해
 *   모달조차 띄우지 않고 넘긴다. 즉 장애가 아니라 **의도된 사용자 플로우**다.
 * - 이런 코드까지 warn으로 올리면 SigNoz의 rolling 리포트 예산을 정상 흐름이 잠식한다.
 *   429 `tooManyRequests` · `TOKEN_NOT_EXIST`를 제외하는 것과 같은 논리로 제외한다.
 */
export function isPassHandledError(error: unknown, meta: PassHandledMeta): boolean {
  if (!(error instanceof AxiosError)) return false;

  const code = (error.response?.data as { code?: string } | undefined)?.code;
  if (!code) return false;

  return meta?.errorMessage?.[code] === PASS_ERROR_MESSAGE;
}
